import * as yup from "yup";

export default yup.object().shape({
    project: yup.string().required(),
});
